import * as React from "react";
import { useEffect, useState } from "react";
import { useGetGameImage } from "../../../hooks/getGameImage";
import { Alert, Spinner, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export const StoreImage: React.FC<{
    src: string;
    platform: string;
    alt?: string;
    thumbnail?: boolean;
    fluid?: boolean;
    className?: string;
    onClick?: (image: { image: string; platform: string; alt?: string }) => void;
}> = (props) => {
    const { src, alt, thumbnail, fluid, className, onClick, platform } = props;

    const { t } = useTranslation();

    const [image, setImage] = useState<string | null>();

    const { sendRequest: fetchGameImage } = useGetGameImage();

    const clickHandler = () => {
        if (onClick) {
            onClick({ image: src, platform: platform, alt: alt });
        }
    };

    useEffect(() => {
        fetchGameImage({ image: src, platform: platform }, (image) => {
            setImage(image);
        });
    }, [fetchGameImage, src, platform]);

    return (
        <>
            {!image && image !== null ? (
                <Alert variant={"primary"}>
                    <Spinner animation={"border"} size={"sm"} /> {t("Image is loading")}
                </Alert>
            ) : (
                <>
                    {image ? (
                        <Image
                            src={image}
                            alt={alt}
                            thumbnail={thumbnail}
                            fluid={fluid}
                            className={className}
                            onClick={clickHandler}
                        />
                    ) : null}
                </>
            )}
        </>
    );
};
